<template>
  <div>
    <PublicShell :igreja="igreja" titulo="Catálogo de Profissionais" :valido="!!igrejaId" max-width="820px">
      <p class="pub-intro">Selecione o serviço:</p>
      <v-data-iterator :items="iterador.conteudo" :items-per-page.sync="iterador.itensPorPagina" hide-default-footer :loading="iterador.carregamento">
                        <template v-slot:header>
                          <v-autocomplete outlined dense :disabled="iterador.servicos.length == 0" v-model="servicoSelecionado" :items="iterador.servicos" hide-details item-text="nome" item-value="id" color="#00695C" label="SERVIÇOS" no-data-text="Sua igreja ainda não cadastrou serviços" @input="searchInput = null" :search-input.sync="searchInput" @change="carregaProfissionais"></v-autocomplete>
                        </template>
                        <template v-slot:no-data>
                          <v-alert v-if="!servicoSelecionado" class="mt-5 mb-0" type="info" dense text>Selecione um serviço acima para visualizar o catálogo</v-alert>
                          <v-alert v-if="servicoSelecionado && iterador.conteudo.length == 0" class="mt-5 mb-0" type="info" dense text>Nenhum profissional localizado para o serviço selecionado</v-alert>
                        </template>
                        <template v-slot:loading>
                          <v-progress-linear class="mt-5 mb-0" indeterminate color="primary"></v-progress-linear>
                          <p class="mt-2 mb-0" style="text-align: center">Carregando itens...</p>
                        </template>
                        <template v-slot:default="props">
                          <v-row>
                            <v-col v-for="item in props.items" :key="item.name" cols="12" xs="12" sm="12" md="4" lg="4">
                              <v-card outlined class="cp-card-prof">
                                <v-list dense>
                                  <v-card-title>{{ item.nome.split(' ').slice(0, 2).join(' ') }}</v-card-title>
                                  <v-list-item style="text-align: center">
                                    <v-list-item-content style="padding: 0px">Serviços que atua:</v-list-item-content>
                                  </v-list-item>
                                  <v-list-item v-for="(profissao, index) in item.servicos" :key="index">
                                    <li>{{ profissao }}</li>
                                  </v-list-item>
                                  <v-list-item style="text-align: center; height: 50px">
                                    <v-list-item-content style="padding: 0px">{{ item.telefone }}</v-list-item-content>
                                    <v-btn icon :href="'tel:' + (item.telefone || '').replace(/\D/g, '')" target="_blank" @click="salvaClique('TELEFONE', item.id)">
                                      <v-icon color="#00695C">mdi-phone</v-icon>
                                    </v-btn>
                                    <v-btn icon :href="'https://wa.me/55' + (item.telefone || '').replace(/\D/g, '')" target="_blank" @click="salvaClique('WHATSAPP', item.id)">
                                      <v-icon color="#25D366">mdi-whatsapp</v-icon>
                                    </v-btn>
                                  </v-list-item>
                                </v-list>
                              </v-card>
                            </v-col>
                          </v-row>
                        </template>
      </v-data-iterator>
    </PublicShell>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import axios from 'axios'
import PublicShell from '../../componentes/PublicShell.vue'

export default {
  name: 'CatalogoProfissionalPublico',
  components: { Snackbar, Loading, PublicShell },
  data() {
    return {
      igrejaId: '',
      igreja: {},
      iterador: { carregamento: false, conteudo: [], itensPorPagina: -1, servicos: [] },
      servicoSelecionado: '',
      searchInput: null,
      isLoading: false,
      fullPage: true,
    }
  },
  mounted() {
    this.igrejaId = this.$route.query.igrejaId || ''
    if (this.igrejaId) this.carregaDados()
  },
  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.igrejaId } })
        if (response.data) {
          this.igreja = response.data
          this.carregaProfissoes()
        }
      } catch (error) {
        this.igrejaId = ''
      } finally {
        this.isLoading = false
      }
    },
    async carregaProfissoes() {
      await axios.post(baseApiUrl + 'ServicoProfissionals/listarPublicos', { igrejaId: this.igreja.id })
        .then(response => { if (response.data.length > 0) this.iterador.servicos = response.data })
    },
    async carregaProfissionais() {
      this.iterador.carregamento = true
      this.iterador.conteudo = []
      await axios.post(baseApiUrl + 'Profissionais/profissionaisComServicos', { igrejaId: this.igreja.id, servicoId: this.servicoSelecionado })
        .then(response => {
          if (response.data.length > 0) this.iterador.conteudo = response.data
          this.iterador.carregamento = false
        })
        .catch(() => {
          this.iterador.carregamento = false
          this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao carregar profissionais. Tente novamente.', 'ERRO')
        })
    },
    async salvaClique(tipo, id) {
      await axios.post(baseApiUrl + 'Interacoes/registrarPublica', { tipo: tipo, profissionalId: id, igrejaId: this.igreja.id })
    },
  },
}
</script>

<style scoped>
.pub-intro { color: #5b6b67; margin: 0 0 6px; font-size: .95rem; }
.cp-card-prof { border-radius: 16px !important; box-shadow: 0 4px 16px rgba(0, 37, 62, 0.08) !important; }
</style>
